var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916992 6.11593V6.11619C0.916818 6.6186 1.02037 7.11563 1.22116 7.57617L1.28366 7.71953V7.79785C1.44754 8.12931 1.66501 8.43187 1.92758 8.69318L0.916992 6.11593ZM0.916992 6.11593V4.39995C0.916992 3.43192 1.30154 2.50355 1.98604 1.81905C2.67054 1.13455 3.59892 0.75 4.56694 0.75H25.1C26.0681 0.75 26.9965 1.13455 27.681 1.81905C28.3655 2.50354 28.75 3.43192 28.75 4.39995V6.10423C28.7335 6.60639 28.6135 7.09979 28.3975 7.5535L28.3247 7.70648V7.79785C28.1607 8.12947 27.9431 8.43215 27.6804 8.69355L27.679 8.6949L18.7031 17.6708L18.4834 17.8905V18.2011V24.9318C18.4829 25.0638 18.4458 25.1931 18.3764 25.3054C18.307 25.4177 18.2079 25.5086 18.0901 25.5682C18.0898 25.5683 18.0896 25.5685 18.0893 25.5686L12.2248 28.5009L12.2248 28.5008L12.2182 28.5042C12.1186 28.5552 12.0086 28.5822 11.8967 28.583C11.7634 28.5832 11.6326 28.5463 11.5191 28.4762C11.4164 28.4118 11.3317 28.3222 11.273 28.2161C11.2141 28.1095 11.1833 27.9897 11.1835 27.8679V27.8664V18.2011V17.889L10.9621 17.6691L1.92795 8.69355L0.916992 6.11593Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6c35ba83.svg";
export { ForwardRef as ReactComponent };